import { Component, Input, OnInit } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { FieldType, FieldTypeConfig } from '@ngx-formly/core'
import { selectOption } from 'src/types/wizard'

@Component({
		selector: 'gwc-checkbox',
		templateUrl: './checkbox.component.html',
		styleUrls: ['./checkbox.component.scss'],
		imports: [
			ReactiveFormsModule,
			MatCheckboxModule
		]
})

export class CheckboxComponent extends FieldType<FieldTypeConfig> {
	public label!: string

	ngOnInit(): void {
		this.label = this.props.label as string
	}
}
